module.exports = __webpack_public_path__ + "img/pwa-ios-2.8017f791.png";